(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/views/toplists/receiver-toplists-empty.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/views/toplists/receiver-toplists-empty.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.views.ReceiverToplistsEmpty = Marionette.View.extend({
    template: function(data) {
      return svs.grassroots.templates.receiver_toplists_empty(data);
    },

    tagName: 'div',
    className: 'empty-toplist'
  });
})(Backbone, _, svs);


 })(window);